// First - check 'ЮЛ' or 'ИП'
// Next create LocalStorage Objects or Send Notification 'Не ЮЛ'
import { clearEmptyObjects } from "./commonUtils";

export class FnsDataManager {
  constructor(
    fnsApi,
    FNS_KEY,
  ){
    this.fnsApi = fnsApi;
    this.FNS_KEY = FNS_KEY;
  }

  fnsReqDataPacker(inn) {
    let data = {
      req: inn,
      key: this.FNS_KEY
    };

    let formBody = [];
    for (let property in data) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody = formBody.join("&");
  }

  async handleCompanyGetBoData(inn) {
    const localObject = JSON.parse(localStorage.getItem(`Bo ${inn}`));
    // const localFnsDataBo = JSON.parse(localStorage.getItem(`rivalFnsBo ${inn}`));
    if(localObject === null) {
      // if(localFnsDataBo === null) {
      const res = await this.fnsApi.getFirmBo(this.fnsReqDataPacker(inn));
      localStorage.setItem(`Bo ${inn}`, JSON.stringify(res[inn]));
      console.log('Request');
      return res[inn];
    } else {
      console.log('Local');
      // localStorage.setItem(`Bo ${inn}`, localObject.inn);
      // localStorage.setItem(`Bo ${inn}`, localFnsDataBo);
      return localObject;
      // return localFnsDataBo;
    }
  }

  async handleCompanyGetEgrData(inn) {
    console.log('innFNS', inn);

    const localFnsDataEgr = JSON.parse(localStorage.getItem(`Egr ${inn}`));
    console.log('localFnsDataEgr', localFnsDataEgr);

    // const localFnsDataEgr = JSON.parse(localStorage.getItem(`rivalFnsEgr ${inn}`));
    if(localFnsDataEgr === null) {
      const res = await this.fnsApi.getFirmEgr(this.fnsReqDataPacker(inn));
      localStorage.setItem(`Egr ${inn}`, JSON.stringify(res.items[0]));
      console.log('Request');
      return res.items[0];
    } else {
      console.log('Local');
      console.log(localFnsDataEgr);
      // localStorage.setItem(`Egr ${inn}`, localFnsDataEgr);
      return localFnsDataEgr;
    }
  }

  staffAmount(egrDataObject) {
    const data = [];
    if(egrDataObject.ЮЛ.История.ОткрСведения !== undefined) {
      egrDataObject.ЮЛ.История.ОткрСведения.forEach((item) => {
        if(item.КолРаб !== undefined) {
          data.push({
            year: item.Дата.slice(0, 4)-1,
            staff: item.КолРаб*1,
          });
        }
      })
    }
    if(egrDataObject.ЮЛ.ОткрСведения !== undefined) {
      data.push({
        year: egrDataObject.ЮЛ.ОткрСведения.Дата.slice(0, 4)-1,
        staff: egrDataObject.ЮЛ.ОткрСведения.КолРаб*1,
      });
    }
    return data;
  }

  async makeFnsDataObject(inn) {
    const egrData = await this.handleCompanyGetEgrData(inn);

    console.log('egrData', egrData);


    const boData = await this.handleCompanyGetBoData(inn);
    const joinedFnsData = {
      name: egrData.ЮЛ.НаимСокрЮЛ,
      inn: inn,
      bo: boData,
      staff: this.staffAmount(egrData),
    }

    return joinedFnsData;
  }

  // Make Universal Util
  // fillTotalRivals(companyData, object) {
  //   const isObjectPresent = companyData.rivals.some(obj => obj.inn === object.inn);
  //   !isObjectPresent && companyData.rivals.push(object);
  //   clearEmptyObjects(companyData.rivals);
  // }

  // pushToRivalsToShow(object) {
  //   this.rivalsToShow.push(object);
  // }

  // // Make universal
  // deleteEmptyRivalToShow(rivalsToShow) {
  //   const hasEmptyObject = rivalsToShow.some(obj => Object.keys(obj).length === 0);
  //   hasEmptyObject && this.rivalsToShow.filter(obj => Object.keys(obj).length > 0)
  // }

  // // Make Universal Util
  // fillRivalsToShow(rivalsToShow, object) {
  //   console.log('object', object);
  //   console.log('rivalsToShow', rivalsToShow);
  //   const isObjectPresent = rivalsToShow.some(obj => obj.inn === object.inn);
  //   console.log('isObjectPresent', isObjectPresent);

  //   if(!isObjectPresent) {
  //     this.pushToRivalsToShow(object);
  //   }
  // }

  // async addRivalsToCompanyObject(companyData, inn) {
  //   const isObjectInDB = companyData.rivals.some(obj => obj.inn === inn);
  //   if(isObjectInDB) {
  //     console.log('Rival From DB');
  //     const rivalFromDB = companyData.rivals.find(obj => obj.inn === inn);
  //     this.fillRivalsToShow(rivalFromDB);
  //   } else {
  //     const localObject = JSON.parse(localStorage.getItem(`${inn}`));
  //     console.log('localObject', localObject);
  //     if(localObject) {
  //       console.log('Local Rival');
  //       this.fillTotalRivals(localObject);
  //       this.fillRivalsToShow(localObject);
  //     } else {
  //       console.log('New Rival');
  //       const newRival = await this.makeFnsDataObject(inn);
  //       // Test
  //       localStorage.setItem(`${inn}`, newRival);
  //       this.fillTotalRivals(newRival);
  //       this.fillRivalsToShow(newRival);
  //     }
  //   }
  // }

  // async handleRivalsInputsDataSubmit() {
  //   const rivalsInputs = document.querySelector('.benchmarking__rivalsForm').querySelectorAll('.benchmarking__rival');
  //   const promises = [];

  //   console.log('rivalsInputs', rivalsInputs);

  //   rivalsInputs.forEach((elem) => {
  //     promises.push(this.addRivalsToCompanyObject(elem.value));
  //   });
  //   console.log('promises', promises);
  //   await Promise.all(promises);

  //   this.deleteEmptyRivalToShow();
  //   // saveData(companyData);
  // }

  // handleRivalDelete(evt, companyData) {
  //   const currentInput = evt.target.closest('.benchmarking__inputCard');

  //   const currentInputInn = currentInput.querySelector('.benchmarking__rival').value;
  //   const rivalToDelete = companyData.rivals.find(rival => rival.inn === currentInputInn);
  //   rivalToDelete
  //     ? this.rivalsToShow.filter(obj => obj.inn !== rivalToDelete.inn)
  //     : this.deleteEmptyRivalToShow();
  // }
}
